import { render } from "./scratchAndWin.vue?vue&type=template&id=1d47ff1b&scoped=true&ts=true"
import script from "./scratchAndWin.vue?vue&type=script&lang=ts"
export * from "./scratchAndWin.vue?vue&type=script&lang=ts"

import "./scratchAndWin.vue?vue&type=style&index=0&id=1d47ff1b&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d47ff1b"]])

export default __exports__